<template>
    <div>
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina"> TRASLADO HARINA ENTRE BODEGAS </v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas"><v-icon color="blue" large>help</v-icon></v-alert>
                    </v-col>
                </v-row>
                <modal-ayuda></modal-ayuda>
            </v-card-text>
        </v-card>
        <v-card>
            <div class="ml-2 mr-2 mb-6">
                <EncabezadoMovimientos 
                    :bodegasOrigen="bodegasOrigen" 
                    :bodegasDestino="bodegasDestino" 
                    :tipos="tipos" 
                    :motivos="motivos"
                    :movimiento="movimiento"
                    @set-data="setDataEncabezado"
                    @cargar-lotes="cargarLotes"
                    @cargar-maxisacos="cargarMaxisacos"
                    @cargar-documentos="cargarDocumentos"
                />
            </div>
        </v-card>
        <v-row class="ml-2 mr-2" v-if="alert">
            <v-col>
                <v-alert
                    dense
                    text
                    type="success"
                >
                Despacho Generado Correctamente <strong>!</strong> <v-btn icon class="float-right" color="green darken-3" @click="alert=!alert"><v-icon>cancel</v-icon></v-btn>
                </v-alert>
            </v-col>
        </v-row>

        <v-row class="ml-1 mr-1">
            <MaxisacosSalida
                    :lotesOrigen="lotes"
                    :loteSelected="lote"
                    :bodegaOrigen="bodega_origen"
                    @lotes-salientes="setLotesSalientes"
            />
        </v-row>


        <v-row>
            <v-col class="col-md-3 offset-md-6 ">
                <v-btn dark rounded class="text-center" color="green darken-1" @click="generarSalida">GRABAR TRASLADO</v-btn>
            </v-col>
        </v-row>
    </div>
   
</template>
<script>
import { mapState,mapMutations } from 'vuex'
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ModalAyudas from '@/components/shared/ModalAyudas.vue';
import EncabezadoMovimientos from '@/components/movimientos/EncabezadoMovimientos.vue'
import MaxisacosSalida from '@/components/movimientos/MaxisacosSalida.vue'

export default {
    data:()=>({
        fecha: '',
        lote: {id:''},
        traer_lote: '',
        lotes: [],
        jumbos: [],
        jumbos_repaso: [],
        checkbox_select: false,
        all_repaso: false,
        alert: false,
        bodega_origen: 2,
        bodega_destino: 3,
        movimiento: {bodega_origen: 2, bodega_destino: 3},
        tipo: 'S',
        motivo: 1,
        motivos: [],
        tipos: [],
        bodegas: [],
        bodegasOrigen: [],
        datos_adicionales: [],
        maxisaco: {},
        maxisacos: [],
        maxisacos_ordenados: [],
        maxisacos_lote: [],
    }),
    mounted(){
        this.fecha = this.moment().format('YYYY-MM-DD HH:mm');
        this.cargarBodegas();
        this.cargarMotivos();
        this.cargarTipos();
    },
    methods:{
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Traslado Harina entre Bodegas`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se registran las traslados de maxisacos entre las bodegas externas. `},
                {   tipo:`label`,   texto:`- Primero se registran los datos generales como la Fecha, Bodega Origen, Bodega Destino, Tipo Movimiento y Motivo Movimiento`},
                {   tipo:`label`,   texto:`- Luego otros datos (documentos, nros de folio) `},
                {   tipo:`label`,   texto:`- Donde dice Bodega Origen (Seleccione Lote) se buscan los lotes y maxisacos que están disponibles para traslado... para seleccionar maxisacos, se busca el lote y se marcan los maxisacos, para luego hacer clic en la flecha azul que apunta hacia la derecha y dejarlos en Bodega Destino `},
                {   tipo:`label`,   texto:`- Si se necesita volver un maxisaco desde "Bodega Destino" a "Bodega Origen", se desmarca el maxisaco y se le da click a la flechita azul que apunta hacia la izquierda `},
                {   tipo:`label`,   texto:`- Finalmente con el botón "Grabar Traslado" se guarda el Movimiento`},
            ];
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarBodegas(){
            let url = `${this.base_url}bodegas`;
            await this.axios.get(url,this.headers).then((res)=>{
                this.bodegas = res.data.data;
                this.bodegasOrigen = this.bodegas.filter(b => ((b.tipo_bodega == 'bodega') && (!b.depende_de))) ;
            }).catch((error)=>{
                console.log('error',error);
            });
        },
        async cargarMotivos(){
            await this.axios.get(`${this.base_url}movimiento/motivos`,this.headers).then((res)=>{
                let resp = res.data.data;
                this.motivos = resp.filter(b => (b.motivo == 'devolucion' || b.motivo == 'traslado'));
            }).catch((e)=>{
                console.log(e);
            });
        },
        async cargarTipos(){
            await this.axios.get(`${this.base_url}movimiento/tipos`,this.headers).then((res)=>{
                let resp = res.data.data;
                this.tipos = resp.filter(b => b.valor == 'S');
                
            }).catch((e)=>{
                console.log(e);
            });
        },

        // viene del evento generado en EncabezadoMovimientos
        setDataEncabezado(data){
            this.bodega_origen = data.bodega_origen
            this.bodega_destino = data.bodega_destino
            this.fecha = data.fecha
            this.tipo = data.tipo
            this.motivo = data.motivo
            this.datos_adicionales = data.datos_adicionales
        },

        // viene del evento generado en EncabezadoMovimientos
        cargarLotes(datita){
            this.lotes = datita.lotes;
            this.lote = datita.lote;
        },

        // viene del evento generado en EncabezadoMovimientos
        cargarMaxisacos(data){
            this.setDataEncabezado(data)
            this.maxisacos_lote = data.maxisacos_lote;
        },
        // viene del evento generado en EncabezadoMovimientos
        cargarDocumentos(data){
            this.setDataEncabezado(data)
            this.documentos = data.documentos;
            this.datos_adicionales = data.datos_adicionales;
        },

        // viene del evento generado en MaxisacosSalida
        setLotesSalientes(datita){
            this.lotesSalientes = datita;
        },

        async generarSalida(){
            let errors = [];
            let infos = [];
            this.datos_adicionales.forEach(da => {
                let info = {
                    mov_documentos_id: da.mov_documentos_id,
                    valor_dato: da.valor_dato,
                    valor_fecha: da.valor_fecha,
                };
                infos.push(info);
            });
            (((this.bodega_origen === null) || (this.bodega_origen == '')) && (this.bodega_origen !== 0)) ? errors.push("Falta Bodega de Origen") : null;
            (((this.bodega_destino === null) || (this.bodega_destino == '')) && (this.bodega_destino !== 0)) ? errors.push("Falta Bodega de Destino") : null;
            !this.fecha ? errors.push("Falta fecha de la salida") : null;
            !this.tipo ? errors.push("Falta tipo") : null;
            !this.motivo ? errors.push("Falta motivo") : null;

            let detalles = [];
            this.lotesSalientes.forEach(ls => {
                ls.jumbos.forEach(j => {
                    detalles.push({jumbo_id: j.id, observacion: '.'});
                });
            });
            if(detalles.length == 0){
                errors.push("Debe indicar jumbos que salieron a reproceso");
            }
            
            let cambios = [];
            detalles.forEach(d => {
                cambios.push({id: d.jumbo_id, bodega_destino: this.bodega_destino});
            });
            if(errors.length > 0){
                console.log(errors);
                this.errorMessage(errors, "Falta Información");
                return;
            }
            //this.mostrarLoading('Generando Salida ...');
            this.mostrarLoading({titulo:'Generando Traslado...',color:'green'})

            let data = {
                infos: infos,
                movimiento: {
                    fecha: this.fecha,
                    tipo_movimiento: this.tipo,
                    motivo_movimiento: this.motivo,
                    bodega_origen: this.bodega_origen,
                    bodega_destino: this.bodega_destino,
                },
                detalles: detalles,
                cambios: cambios
            }
            let url = `${this.base_url}movements`;
            await this.axios.post(url, data, this.headers).then((res)=>{
                console.log(res.data);
                this.jumbos_repaso = [];
                this.lote = {};
                this.jumbos = [];
                this.maxisaco = {};
                this.maxisacos = [];
                this.datos_adicionales.forEach(da => {
                    da.valor_dato = '';
                });
                this.ocultarLoading();
                this.mostrarLoading({titulo:res.data.respuesta,color:'green'})
            }).catch((error)=>{
                this.ocultarLoading();
                console.log('error',error);
                this.errorMessage(error, "No se grabó La salida");

                //this.ocultarLoading();
            });
        },
        
        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },
    computed:{
        bodegasDestino(){
            if(this.bodega_origen){
                return this.bodegas.filter(b => ((b.tipo_bodega == 'bodega') && !b.depende_de && ( b.id !== this.bodega_origen)));
            }
            return this.bodegas.filter(b => (b.tipo_bodega == 'bodega' && !b.depende_de));
        },
        ...mapState(['base_url','headers'])
    },
    components:{
        DatePicker,
        'modal-ayuda':ModalAyudas,
        EncabezadoMovimientos,
        MaxisacosSalida,
    }
}
</script>
<style scoped>
    .v-input--selection-controls {
        margin-top: 0px;
        padding-top: 0px;
    }
    .mx-datepicker{
        width: 100% !important;
    }
    .inputcito{
        border:1px solid #ccc;
        margin:0.5em 0.5em;
    }
</style>